/**
 * [通过参数名获取url中的参数值]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param  {[string]} queryName [参数名]
 * @return {[string]}           [参数值]
 */
export function getQueryValue(queryName) {
  var reg = new RegExp("(^|&)" + queryName + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
}
/**
 * 跳转路由
 * @param {*} route
 */
export function jumpUrl(route) {
  window.location.href =
    window.location.protocol + "//" + window.location.host + "/" + route;
}
/**
 * 判断是不是微信浏览器
 */
export function isWechat() {
  var ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf("micromessenger") !== -1;
  return isWeixin;
}
/**
 * 返回年份
 */
export function getYear() {
  var myDate = new Date();
  var tYear = myDate.getFullYear();
  var tMonth = myDate.getMonth() + 1;
  if (tMonth >= 8) {
    tYear++;
  }
  return tYear;
}
/**
 * 校验正负正数就返回true
 **/
export function isNumber(value) {
  var patrn = /^(-)?\d+(\.\d+)?$/;
  if (patrn.exec(value) === null || value === "") {
    return false;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/utils/tool.js